import moment from "moment";
import { Data } from "dataclass";
import { TripKeyInfoDateRangeDto, TripKeyInfoDto } from "./tripkeyinfo.dto";

export class TripKeyInfoViewModel extends Data {
  tripId: string;
  tripName: string = "";
  createdAt: string = "";
  schedules: string[] = [];
  status: string = "";
  influencerName: string = "";
  price: string = "";
}

export const mapToTripKeyInfoViewModel = (trips: TripKeyInfoDto[]) => {
  return trips.map((trip) => {
    return mapToVm(trip);
  });
};

const dateRangeToText = (dateRanges: TripKeyInfoDateRangeDto): string => {
  const startDate = moment(dateRanges.from).format("ll");
  const endDate = moment(dateRanges.to).format("ll");
  return startDate + " - " + endDate;
};

const mapToVm = (trip: TripKeyInfoDto): TripKeyInfoViewModel => {
  return TripKeyInfoViewModel.create({
    tripId: trip.tripId,
    tripName: trip.tripName,
    createdAt: moment(trip.createdAt).format("ll"),
    schedules: trip.tripDates.map((dateRanges) => dateRangeToText(dateRanges)
    ),
    status: trip.status,
    price: "₹ " + trip.price.toString(),
    influencerName: trip.influencerName
  });
};

